import TopBar from "./components/TopBar";
import Hero from "./components/Hero";
import HotIndex from "./components/HotIndex";
import TopicGrid from "./components/TopicGrid";
import QueryZone from "./components/QueryZone";
import RankFeed from "./components/RankFeed";
import Guide from "./components/Guide";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <TopBar />
      <main>
        {/* 首屏：双栏文+图对开，版面较疏 */}
        <Hero />
        {/* 索引 / 合集：热榜与热词 */}
        <HotIndex />
        {/* 专题精选：封面驱动，大小卡混排 */}
        <TopicGrid />
        {/* 内容查询：按领域分区 */}
        <QueryZone />
        {/* 更新动态：持续归档 */}
        <RankFeed />
        {/* 使用指引 */}
        <Guide />
      </main>
      <Footer />
    </div>
  );
}